__turbopack_context__.v({
  "borderNone": "HorizontalSection-module-scss-module__wMVs4q__borderNone",
  "center": "HorizontalSection-module-scss-module__wMVs4q__center",
  "horizontalSection": "HorizontalSection-module-scss-module__wMVs4q__horizontalSection",
  "subtitle": "HorizontalSection-module-scss-module__wMVs4q__subtitle",
  "title": "HorizontalSection-module-scss-module__wMVs4q__title",
  "titleBlock": "HorizontalSection-module-scss-module__wMVs4q__titleBlock",
});
